import { sheinPlatformAPI } from '@/utils/api';

/**
 * 点击「编辑」前校验平台是否允许编辑该 SPU。
 * @returns {{ ok: true, spuName: string } | { ok: false, reason: string, spuName: string }}
 */
export async function checkSheinProductEditable(shopId, spuName) {
  const spu = String(spuName || '').trim();
  if (!shopId) {
    return { ok: false, reason: '请先选择店铺', spuName: spu };
  }
  if (!spu || spu === '—') {
    return { ok: false, reason: '缺少平台 SPU，无法校验是否可编辑', spuName: spu };
  }
  try {
    const res = await sheinPlatformAPI.checkEditPermission(shopId, { spuName: spu });
    if (res?.canEdit === false) {
      return {
        ok: false,
        reason: res?.reason || '当前商品不可编辑（可能正在审核中）',
        spuName: spu,
        raw: res,
      };
    }
    return { ok: true, spuName: spu, raw: res };
  } catch (e) {
    return {
      ok: false,
      reason: e?.message || '校验是否可编辑失败',
      spuName: spu,
    };
  }
}
